import React, { useCallback } from 'react';
import { useModal } from 'components/shared';
import { GlpSignUpTypeformModal } from './GlpSignUpTypeformModal';

export const useGlpSignUp = (defaultFlow = 'pl_glp_signup') => {
  const modal = useModal();

  return useCallback(
    (flow?: string | React.SyntheticEvent) => {
      const resolvedFlow = typeof flow === 'string' ? flow : defaultFlow;
      modal.set(React.createElement(GlpSignUpTypeformModal, { flow: resolvedFlow }));
      modal.setCloseButtonTheme('light');
      modal.show();
      modal.setPortal(true);
    },
    [defaultFlow, modal],
  );
};
